;(function (angular, _, moment, numeral) {
  'use strict'

  angular
    .module('kilo.routes.order.list')
    .controller('OrderListController', OrderListController)

  OrderListController.$inject = [
    // Urls
    'urls',

    // Angular
    '$state', '$http', '$uibModal', '$window', '$scope',

    // Managers
    'InvoiceManager', 'OrderManager',

    // Services
    'DatePickerService', 'SnackService', 'UtilService',
    'FilterSidebarService', 'ColumnService', 'SelectionService',
    'PreferencesService', 'DisplayService', 'FilterService', 'StatusService',

    // Resolve
    'pagination', 'linkedSearch', 'referers'

  ]

  function OrderListController (
    // Urls
    urls,

    // Angular
    $state, $http, $uibModal, $window, $scope,

    // Managers
    InvoiceManager, OrderManager,

    // Services
    DatePickerService, SnackService, UtilService,
    FilterSidebarService, ColumnService, SelectionService,
    PreferencesService, DisplayService, FilterService, StatusService,

    // Resolve
    pagination, linkedSearch, referers

  ) {
    var self = this

    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        pagination: pagination,
        referers: referers,
        statuses: StatusService.getStatuses('order'),
        archive: [
          { label: 'Non-archivées', value: false },
          { label: 'Archivées', value: true },
          { label: 'Toutes', value: 'both' }
        ],
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,

        // Methods
        addCriteria: addCriteria,
        archiveOrder: archiveOrder,
        clearSearch: clearSearch,
        dropColumn: dropColumn,
        fullTotalFallback: fullTotalFallback,
        groupFind: FilterService.groupFind,
        getDateColor: getDateColor,
        getFullTotal: getFullTotal,
        getOrderDiscountedTotal: getOrderDiscountedTotal,
        getOrderNumber: getOrderNumber,
        getList: getList,
        go: go,
        isLate: isLate,
        isVisible: isVisible,
        newTab: newTab,
        restoreOrder: restoreOrder,
        searchClients: searchClients,
        searchOrderRef: searchOrderRef,
        searchOrderTitle: searchOrderTitle,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCompanyPrefsValid: isCompanyPrefsValid,
        sort: sort,
        searchBpus: searchBpus
      })

      $scope.$on('OrderBulkValidate', refreshList)

      init()
    }

    function init () {
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
        self.columns = ColumnService.getColumns('order')
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.orderList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.orderList, 'pagination')
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
          }
        }

        initLinkedSearch()
        self.selection.selectedData = []
        getList()
      })
    }

    function saveColumns () {
      self.prefs.settings.orderList.columns = self.columns
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('order')
      })
    }

    function isCompanyPrefsValid () {
      return PreferencesService.isCompanyPrefsValid()
    }

    function resetColumns () {
      self.prefs.settings.orderList.columns = ColumnService.getDefaultColumns('order')
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('order')
      })
    }

    function refreshList () {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = []
      }
      self.sideBar.init()
      getList()
    }

    function initLinkedSearch () {
      if (linkedSearch && !angular.equals({}, linkedSearch)) {
        self.sideBar.filterVisible = true
        if (linkedSearch.hasOwnProperty('status') || linkedSearch.hasOwnProperty('client') || linkedSearch.hasOwnProperty('label')) {
          if (linkedSearch.status) {
            addCriteria('status', _.find(self.statuses, function (s) { return s.status === linkedSearch.status }))
          }
          if (linkedSearch.client && linkedSearch.label) {
            addCriteria('client', { _id: linkedSearch.client, label: linkedSearch.label })
          }
        } else {
          self.pagination.search = linkedSearch
        }
      }
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('order')
      })
    }

    function archiveOrder (order) {
      var content = 'Vous êtes sur le point d\'archiver ce chantier.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Archiver', content).then(function () {
        order.archive().then(function () {
          SnackService.snack({
            text: 'Chantier archivé !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreOrder (order) {
      var content = 'Vous êtes sur le point de restaurer ce chantier.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        order.restore().then(function () {
          SnackService.snack({
            text: 'Chantier restauré !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function newTab (id) {
      var url = $state.href('order.show', { id: id })
      $window.open(url, '_blank')
    }

    function go (order) {
      $state.go('order.show', { id: order })
    }

    function getOrderNumber (order) {
      if (order.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(order, 'order', order.numberFormat)
    }

    function getFullTotal (order) {
      var vats = _.reduce(order.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          var vat = line.VAT
          var vatTotal = _.find(acc, { vat: vat })
          if (!vatTotal) {
            vatTotal = { vat: vat, amount: 0 }
            acc.push(vatTotal)
          }
          vatTotal.amount += line.discountedTotal * line.VAT / 100
          return acc
        }, [])
      var total = _.reduce(order.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          return acc + line.discountedTotal
        }, 0)
      return total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
    }

    function getOrderDiscountedTotal (order) {
      return _.reduce(order.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          return acc + (line.total - line.discountAmount)
        }, 0)
    }

    function isLate (order) {
      return order.status !== 'paid' && moment().isAfter(moment(order.dueDate))
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function getDateColor (order) {
      if (order.status !== 'paid') {
        if (moment().isAfter(moment(order.dueDate))) {
          return 'red'
        } else if (moment(order.dueDate).subtract(5, 'days') < moment()) {
          return 'orange'
        }
      }
    }

    function fullTotalFallback (order) {
      if (!order.fullTotal || (order.fullTotal === 0 && order.total !== 0)) {
        return self.getFullTotal(order)
      }
      return order.fullTotal
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }

    // SEARCH RELATED

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true

      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search)
      if (!hasArchived) {
        addCriteria('isArchived', { _id: 'archived', value: 'false' })
        return
      }

      var q = {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label'
          },
          {
            path: 'tags',
            select: 'color label'
          },
          { path: 'referers' },
          { path: 'bpu' },
          { path: 'invoices', select: 'createdAt lines payments' }
        ]),
        archived: 'both'
      }

      var query = OrderManager
        .query(q)
        .fields('referers lines number numberFormat reference title client date dueDate status tags total totalVAT balanceDue fullTotal isArchived bpu invoices')
        .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }

      var promise = OrderManager.post(query, { ignoreArchived: true })
      promise.then(function (data) {
        self.loading = false
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.orders = data.data

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.orders.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0
          getList(pagination)
        }
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function searchOrderRef (search) {
      return FilterService.searchOrderRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchOrderTitle (search) {
      return FilterService.searchOrderTitle(search).then(function (titles) {
        self.titles = titles
      })
    }

    function searchClients (search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchTags (query) {
      return FilterService.searchTags(query)
    }

    function selectDateRange () {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('date', dates)
        getList()
      })
    }

    function selectDueDateRange () {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates)
        getList()
      })
    }

    function searchBpus (search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus
      })
    }
  }
})(window.angular, window._, window.moment, window.numeral)
